import * as yup from 'yup'

import { VerifyBackupCodeFields } from './verifyBackupCode.types'

export const verifyBackupCodeSchema = yup.object().shape({
    [VerifyBackupCodeFields.verificationCode]: yup.string().required('AUTH.REQUIRED_FIELD'),
    [VerifyBackupCodeFields.trustedDevice]: yup.boolean(),
})
